import { FormProvider, useForm } from '@slal/ui/react-hook-form/core';
import { Heading } from '@slal/ui/typography';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useFunds } from 'src/context';
import { ButtonGroup, CardButton, ProgressStep, useAnalytics } from '~/components';
import { useFormData } from '~/hooks';
import { getPortfolioReportingPeriod } from '~/utils';
import { InvestmentFundsView, PerformanceChartCard } from '../application';
import { strings } from '../strings';
import { StyledForm } from '../styles';

export const ReportingPeriod = () => {
    const { pushEvent } = useAnalytics();
    const initialized = useRef(false);
    const navigate = useNavigate();
    const { formData, updateFormData } = useFormData();
    useEffect(() => {
        if (!Object.keys(formData).length) {
            navigate('/');
        }
    }, [formData, navigate]);
    const hookForm = useForm();
    const onValidSubmit = (values: Record<string, unknown>) => {
        pushEvent({
            eventCategory: 'Portfolio performance period',
            eventAction: 'Click',
            eventLabel: 'Continue',
        });
        updateFormData(values);
        navigate('/customise-report');
    };

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            pushEvent({
                eventCategory: 'Portfolio performance period',
                eventAction: 'Pageload',
                eventLabel: 'Page 2',
            });
        }
    }, []);

    const handleBackButtonClick = () => {
        pushEvent({
            eventCategory: 'Portfolio performance period',
            eventAction: 'Click',
            eventLabel: 'Back',
        });
        navigate('/');
    };

    const { selectedFunds } = useFunds();
    const maximumPeriod = getPortfolioReportingPeriod(selectedFunds);

    const isContinueButtonVisible = true;
    const [reportingPeriodYears, setReportingPeriodYears] = useState(maximumPeriod);

    return (
        <FormProvider {...hookForm}>
            <StyledForm onSubmit={hookForm.handleSubmit(onValidSubmit)} id="reportingPeriodForm">
                <ProgressStep currentStep={2} totalSteps={3} />
                <Heading level={2}>{strings.reportingPeriod}</Heading>
                <InvestmentFundsView maximumPeriod={maximumPeriod} setReportingPeriodYears={setReportingPeriodYears} />
                <PerformanceChartCard reportingPeriodYears={reportingPeriodYears} />
                <ButtonGroup>
                    {isContinueButtonVisible && <CardButton type="submit">Continue</CardButton>}
                    <CardButton role="button" onClick={handleBackButtonClick} type="button" variant="outline">
                        Back
                    </CardButton>
                </ButtonGroup>
            </StyledForm>
        </FormProvider>
    );
};
